import { z } from 'zod';

export const OverlayFormSchema = z.object({
  updatedAt: z.string().optional(),
  imageUploadUrl: z.string().min(1, 'Overlay is required'),
  name: z
    .string()
    .min(3, 'Overlay name must be at least 3 characters long')
    .regex(/^[a-zA-Z0-9 ]+$/, {
      message: 'Only letters and numbers are allowed',
    })
    .max(100, 'Overlay name cannot exceed 100 characters'),
});
